import OrganizationsDoc from "./OrganizationsDoc.jsx";
import Auth0Doc from "./Auth0Doc.jsx";
import CircleEventsDoc from "./CircleEventsDoc.jsx";
import SubscriptionsDoc from "./SubscriptionsDoc.jsx";
import SquarespaceWebsiteDoc from "./SquarespaceWebsiteDoc.jsx";
import ApiEnvironmentDoc from "./ApiEnvironmentDoc.jsx";

/** Map `topic` query param → chapter component (must match `DOC_SECTIONS` ids). */
export const CHAPTER_COMPONENTS = {
  organizations: OrganizationsDoc,
  auth0: Auth0Doc,
  "circle-events": CircleEventsDoc,
  subscriptions: SubscriptionsDoc,
  "squarespace-website": SquarespaceWebsiteDoc,
  "api-environment": ApiEnvironmentDoc,
};
